/* src/app/private/configrations/configure-users/configure-users.component.scss */
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
.delete-menu-item {
  color: red !important;
  font-weight: bold !important;
}
/*# sourceMappingURL=configure-users.component.css.map */
